
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="giga-actions">
    <div class="giga-actions_full giga-actions_start">
      <ul class="giga-actions_row">
          <li class="giga-action_item">
              <div class="giga-action_search">
                <input type="search" name="" id="" placeholder="Recherche" v-model="search" @input="documentSearch()">
                <button class="giga-search_button">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.7448 22.6899L17.772 16.7171C21.2724 12.4326 20.6421 6.12211 16.3576 2.62172C12.0768 -0.878671 5.76261 -0.248376 2.26222 4.03613C-1.23817 8.32064 -0.607873 14.6311 3.67663 18.1315C7.36461 21.1479 12.6696 21.1479 16.3576 18.1315L22.3304 24.1043C22.7431 24.472 23.3771 24.4382 23.7448 24.0255C24.0862 23.6466 24.0862 23.0726 23.7448 22.6899ZM10.0321 18.3941C5.60879 18.3941 2.02586 14.8149 2.02211 10.3916C2.02211 5.96829 5.60129 2.38536 10.0246 2.38161C14.4479 2.38161 18.0309 5.96078 18.0346 10.3841C18.0346 10.3841 18.0346 10.3879 18.0346 10.3916C18.0271 14.8074 14.4479 18.3866 10.0321 18.3941Z" fill="#8C9DAB"/>
                </svg>
                </button>
            </div>
          </li>
          <filter-modal
              :query-config="queryConfig"
              v-on:onFilter="onFilter($event)"
              v-on:onReloadData="reloadData($event)"
              :headerTitle="'filtrer_document'"
      ></filter-modal>
      </ul>
    </div>



<!--    <b-modal-->
<!--      id="addDocumet"-->
<!--      modal-class="p-4 big-modal modal-scroll"-->
<!--      content-class="text-center pb-2"-->
<!--      no-close-on-esc-->
<!--      no-close-on-backdrop-->
<!--      hide-header-->
<!--      hide-footer -->
<!--      lazy-->
<!--    >-->
<!--    <b-icon icon="x" @click="hideModal('addDocumet')" class="icon-close fsize-5 text-muted"></b-icon>-->
<!--      <transition name="slide-up">-->
<!--        <add-document-step1-->
<!--            :isSimulation="isSimulation"-->
<!--            :isToBeCompleted="toBeCompleted"-->
<!--            :selectDocuments="selectDocuments"-->
<!--        ></add-document-step1>-->
<!--      </transition>-->
<!--    </b-modal>-->

<!--    <b-modal-->
<!--            id="EditDocumentTypes"-->
<!--            modal-class="p-4 big-modal modal-scroll"-->
<!--            content-class="text-center pb-2"-->
<!--            no-close-on-esc-->
<!--            no-close-on-backdrop-->
<!--            hide-header-->
<!--            hide-footer-->
<!--            lazy-->
<!--    >-->
<!--      <b-icon icon="x" @click="hideModal('EditDocumentTypes')" class="icon-close fsize-5 text-muted"></b-icon>-->
<!--      <transition name="slide-up">-->
<!--        <edit-document-type-->
<!--                :documents="getSelectedDocuments"-->
<!--                :action-type="'edit'"-->
<!--        ></edit-document-type>-->
<!--      </transition>-->
<!--    </b-modal>-->
    <confirm-modal id="confirm-delete"
                   :content="$t('would-you-like-to-delete-the-document')"
                   :loader="false"
                   fontSize="h3"
                   backdrop-close="false"
                   @yesClick="deleteDocument()"
                   @close="hideConfirmationModal()"
    ></confirm-modal>


  </div>

</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import eventBus from '@/shared/event.bus';
import ConfirmModal from '../../components/static/ConfirmModal';
import FilterModal from './FilterModal';
import {debounce, some} from 'lodash';

export default {
  name: 'DocumentsFilter',
  props: ['documents', 'selectDocuments','noSearch','noFilter', 'isSimulation', 'queryConfig'],
  components: {FilterModal, ConfirmModal },
  data() {
    return {
      toBeCompleted: false,
      search: '',
      fetchData: () => {}
    }
  },
  mounted(){
    eventBus.$on('setCurrentStep_One', () => {
      this.setCurrentStep(1)
    });
    this.fetchData = debounce(() => {
      this.$emit('applySearch', {search: this.search});
    }, 500);
  },
  computed: {
    ...mapGetters('document', ['getSelectedDocuments']),
    ...mapGetters('loader', {downloadDocumentLoader: 'getDownloadDocumentLoader'}),
    hideDeleteOrReplaceButton() {
      return this.selectDocuments.length > 1 && this.isToBeCompleted;
    },
    isToBeCompleted() {
      return some(this.getSelectedDocuments, { transmitted: false });
    }
  },
  methods: {
    ...mapMutations('document', ['setCurrentStep', 'setStep1Status']),
    ...mapActions('document', ['deleteDocumentsAction']),
    ...mapActions('notification', ['openModal', 'closeModal']),
    // openDocumentModal(modal) {
    //   this.toBeCompleted = false;
    //   if (modal === 'replaceDocument') {
    //     this.toBeCompleted = true;
    //     modal = 'addDocumet';
    //   }
    //   this.$root.$emit('bv::show::modal', modal);
    // },
    // hideModal(modal) {
    //   this.$root.$emit('bv::hide::modal', modal);
    //    this.setCurrentStep(1);
    //   eventBus.$emit('reloadDocuments', null);
    // },
    hideConfirmationModal() {
      this.$root.$emit('bv::hide::modal', 'confirm-delete');
    },
    deleteDocument() {
      this.hideConfirmationModal();
      this.deleteDocumentsAction({documentsIds: this.selectDocuments});
    },
    onFilter(filter) {
      this.$emit('applyFilter', {isSimulationFilter: this.isSimulationContext, filter: filter})
    },
    reloadData(filter) {
      this.$emit('reloadData', {isSimulationFilter: this.isSimulationContext, filter: filter})
    },
    documentSearch() {
      this.fetchData();
    }
  },
};
</script>
